import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { MiniInventoryMap } from 'client/tracking/maps/components/mini-inventory/mini-inventory';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  trim_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.TRIM_SELECT),
  crr_write_review: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WRITE_REVIEW,
    TrackingConstant.GO_TO_REVIEW_FORM
  ),
  crr_all_for_sale: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_MORE_INVENTORY
  ),
  crr_style_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.STYLE_SELECT),
  crr_items_per_page: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ITEMS_PER_PAGE
  ),
  filter_consumer_review_aspect: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_REVIEW,
    TrackingConstant.SEARCH_REVIEW_TOPIC,
    {
      action_cause: 'image_click',
      value: 'view_subcategory_info',
    }
  ),
  consumer_review_aspect_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.VIEW_MORE
  ),
  consumer_review_aspect_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.VIEW_LESS
  ),
  crr_sort_search_result: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SORT_SEARCH_RESULT
  ),
  crr_navigate_to: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATION_TO
  ),
  crr_navigate_next: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATION_NEXT
  ),
  crr_navigate_back: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATION_BACK
  ),
  crr_navigate_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATE_EXPAND
  ),
  crr_navigate_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATE_COLLAPSE
  ),
  crr_core_page_nav: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SELECT_MAKE_MODEL
  ),
  crr_rate_yes: TrackingEvent.actionCompleted(TrackingConstant.ACTION_ENGAGE_SURVEY, TrackingConstant.YES_FEEDBACK),
  crr_rate_no: TrackingEvent.actionCompleted(TrackingConstant.ACTION_ENGAGE_SURVEY, TrackingConstant.NO_FEEDBACK),
  inventory_model_select: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_INVENTORY_SELECT,
    TrackingConstant.MODEL_SELECT
  ),
  open_photoflipper: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_PHOTO,
    TrackingConstant.OPEN_PHOTOFLIPPER,
    { creative_id: 'photoflipper' }
  ),
  appraise_your_car: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.APPRAISE_YOUR_CAR
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...MiniInventoryMap,
  ...map,
};
